import { useTranslation } from "react-i18next";

import { getFacilityCategoryLabel, type HaNFacilityCategory } from "@lib/logic";
import { Icon } from "@atoms";

type FacilityCategoryCardProps = {
  category: HaNFacilityCategory;
  onOpen: () => void;
};

const getIconProps = (category: HaNFacilityCategory) => {
  switch (category.kind) {
    case "area":
      return { icon: "desk" } as const;
    case "room":
      return { icon: "meetingRoom" } as const;
    case "facility":
      return { icon: "location", iconUrl: category.facilityType.lightIconUrl || undefined } as const;
  }
};

export const FacilityCategoryCard = ({ category, onOpen }: FacilityCategoryCardProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className="flex h-full min-h-[84px] w-full flex-col items-center justify-center gap-2 rounded-lg border bg-white px-3 py-4 text-center font-medium leading-5 hover:bg-mapiq-black-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-mapiq-black-900"
      onClick={onOpen}>
      <Icon
        aria-hidden
        size="24px"
        color="currentColor"
        {...getIconProps(category)}
      />
      {getFacilityCategoryLabel(category, t)}
    </button>
  );
};
